import { FlowBuilderService } from '@hubtype/data-access-api'

import { CMSReader } from '../../domain/models/cms'
import { HtContentType } from '../../domain/models/cms/hubtype/node-types'
import { HtNodeComponent } from '../../domain/models/cms/hubtype/nodes'
import { PayloadFields, UrlFields } from '../../domain/models/content-fields'
import { LocaleCode } from '../../domain/models/locales/code'
import { Locale } from '../../domain/models/locales/locale'
import { NodeAction } from '../../UI/reducer/actions/node-actions/node-action'
import {
  FlowContent,
  NonMessageContents,
  OrganizationContents,
} from '../../UI/types'
import { FlowFactory } from './flow-factory'
import { NodeFactory } from './hubtype-node-factory'

export class HubtypeReader implements CMSReader {
  constructor(private readonly flowBuilderService: FlowBuilderService) {}

  async readFlowContent(
    locale: Locale | undefined,
    organizationContents: OrganizationContents,
    version: string
  ): Promise<FlowContent> {
    const botId = organizationContents.currentBot.id
    const data = await this.flowBuilderService.loadFlow(version, botId)
    const nonMessageContents = this.getNonMessageContents(data.nodes)
    const nodeFactory = new NodeFactory(
      [...data.nodes, ...(data.webview_contents || [])],
      locale?.code || (data.locales[0] as LocaleCode),
      data.locales as LocaleCode[],
      organizationContents,
      nonMessageContents
    )
    const nodes = nodeFactory.getNodes()
    const startNode = NodeAction.createStartNode()
    const flows = new FlowFactory(data, startNode).getFlows()
    startNode.data.setErrors()
    nodes.push(startNode)

    return {
      nodes,
      nonMessageContents,
      isKnowledgeBaseActive: data.is_knowledge_base_active,
      locales: data.locales,
      botVariables: data.bot_variables,
      flows,
      hash: data.hash,
    }
  }

  private getNonMessageContents(nodes: HtNodeComponent[]): NonMessageContents {
    const nonMessageContents: NonMessageContents = {
      urls: [],
      payloads: [],
    }
    nodes.forEach(node => {
      if (node.type === HtContentType.URL) {
        nonMessageContents.urls.push(UrlFields.fromHubtypeCMS(node))
      }
    })
    nodes.forEach(node => {
      if (node.type === HtContentType.PAYLOAD) {
        nonMessageContents.payloads.push(PayloadFields.fromHubtypeCMS(node))
      }
    })
    return nonMessageContents
  }
}
